import React from 'react'
import { CaptionText, Divider, Link, PAYPAL_THEME } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'
const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

interface ExampleContainerProps {
  handleClick: (text: string) => void
  sectionData: {
    title: string
    suggestions: { text: string; link: string }[]
  }
  searchID: string
}

const ExampleContainer = ({
  sectionData,
  handleClick,
  searchID,
}: ExampleContainerProps) => {
  const fptiData = typeof window !== `undefined` && window.fpti

  const onLinkResultClick = (category: string, query: string) => {
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          tag: `suggestions-${category}`,
          link: `suggestions-${category}`,
          category,
          query,
          name: 'gen_ai_summary',
          component: 'devdiscoverynodeweb',
          event_label: category,
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
    handleClick(query)
  }
  return (
    <div className={styles.exampleCardContainer}>
      <Divider className={styles.divider} />

      <CaptionText
        className={styles.listTitle}
        style={{ color: sysColorBackgroundMediumContrast }}
      >
        {sectionData.title}
      </CaptionText>

      {sectionData.suggestions.map((item, key) => (
        <Link
          key={key}
          className={styles.listItem}
          onClick={(e) => {
            e.preventDefault()
            onLinkResultClick(sectionData.title, item.text)
          }}
          href={''}
        >
          {item.text}
        </Link>
      ))}
    </div>
  )
}
export default ExampleContainer
